import { apiService } from './apiService';
import { ITransferMail } from '../types/case/transferMail';


export const TransferService = {
    sendData: (transfer: ITransferMail) => {
        apiService.post('/api/transfer', { transfer })
    }
}